import { useState } from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter, Route, Routes, Link } from "react-router-dom"

import Box from '@mui/material/Box'


import Phytoplasma from './Section2/Phytoplasma';
import Wirtspflanzen from './Section2/Wirtspflanzen';
import Symptome from './Section2/Symptome';
import Pictures from './Section2/Pictures';

import Footer2 from './Footer2';

function Part2() {

  return (

    <>

      <Phytoplasma />

      <Wirtspflanzen />

      <Symptome />

      <Pictures />

      <Footer2 />

    </>

  );
}

export default Part2;
